import { autoserialize, autoserializeAs } from 'cerialize';
import { TransitProgramDriverInfo } from './transit-program-driver-info';

export class TransitProgramDriverInfoList {
  @autoserialize
  totalCount: number;

  @autoserializeAs(TransitProgramDriverInfo)
  transitProgramDriverInfos: Array<TransitProgramDriverInfo>;
}
